import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authFetch } from '../../api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiAlertCircle, FiCheckCircle, FiArrowLeft } = FiIcons;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      const res = await authFetch('forget-password', {
        method: 'POST',
        body: JSON.stringify({ email })
      });

      if (res?.status === 'success') {
        setStatus('success');
        setMessage('Password reset instructions have been sent to your email.');
      } else {
        setStatus('error');
        setMessage(res?.error || 'Failed to send reset email. Please ensure the email is registered.');
      }
    } catch (error) {
      console.error('Error in forgot password:', error);
      setStatus('error');
      setMessage('An unexpected error occurred. Please try again.');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden">
        <div className="p-8">
          <div className="flex items-center justify-center gap-2 mb-8">
            <div className="w-10 h-10 bg-slate-900 rounded-xl flex items-center justify-center">
              <SafeIcon icon={FiIcons.FiShield} className="text-[#00E5FF] text-xl" />
            </div>
            <span className="text-2xl font-bold text-slate-800 tracking-tight">Sentinel</span>
          </div>

          <h2 className="text-2xl font-bold text-slate-800 mb-2 text-center">Reset Password</h2>
          <p className="text-slate-500 mb-8 text-center text-sm">Enter your email and we'll send you a link to reset your password.</p>

          {status === 'error' && (
            <div className="mb-6 p-3 bg-red-50 border border-red-100 rounded-lg flex items-start gap-3">
              <SafeIcon icon={FiAlertCircle} className="text-red-500 mt-0.5 flex-shrink-0" />
              <p className="text-sm text-red-700">{message}</p>
            </div>
          )}

          {status === 'success' ? (
            <div className="text-center">
              <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={FiCheckCircle} className="text-3xl" />
              </div>
              <p className="text-sm text-slate-600 mb-6">{message}</p>
              <Link to="/login" className="inline-block bg-slate-900 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-slate-800 transition-all">
                Return to sign in
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Email Address</label>
                <div className="relative">
                  <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full pl-10 pr-4 py-2.5 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900 focus:bg-white transition-all text-sm"
                    placeholder="name@company.com"
                    required
                  />
                </div>
              </div>

              <button
                type="submit"
                disabled={status === 'loading'}
                className="w-full bg-slate-900 text-white py-2.5 rounded-lg text-sm font-medium hover:bg-slate-800 focus:outline-none focus:ring-2 focus:ring-slate-900 focus:ring-offset-2 transition-all disabled:opacity-50 mt-6"
              >
                {status === 'loading' ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="mt-8 flex justify-center">
            <Link to="/login" className="flex items-center gap-2 text-sm text-slate-500 hover:text-slate-900 font-medium transition-colors">
              <SafeIcon icon={FiArrowLeft} /> Back to sign in
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;